{
  "noAssignedModeling": "No assigned project",
  "modelings": "projects",
  "pleaseSignIn": "Please sign in",
  "email": "Email",
  "enterLogin": "Enter UserName",
  "signIn": "Sign in",
  "password": "Password",
  "enterPassword": "Enter password",
  "filterByName": "Filter by name",
  "settings": "Settings",
  "logout": "Logout",
  "home": "Home",
  "users": "Users",
  "areas": "Areas",
  "modelingName": "Project name",
  "passwordChange": "Password change",
  "close": "Close",
  "confirm": "Confirm",
  "userDelete": "Delete user",
  "wannaDeleteThisUser": "Are you sure you want to delete this user?",
  "delete": "Delete",
  "userCreation": "User creation",
  "create": "Create",
  "name": "Name",
  "enterUserName": "Enter user name",
  "loginName": "Login name",
  "role": "Role",
  "chooseRole": "Choose role",
  "projectadmin": "Project Admin",
  "viewer": "Viewer",
  "admin": "Admin",
  "team": "Team",
  "teamName": "Team name",
  "group": "Group",
  "groups": "Groups",
  "chooseGroup": "Choose group",
  "choose": "Choose",
  "groupCreation": "Group creation",
  "enterGroupName": "Enter group name",
  "groupDetail": "Group detail",
  "save": "Save",
  "userDetail": "User detail",
  "string": "String",
  "integer": "Integer",
  "decimal": "Decimal",
  "dateTime": "Date time",
  "boolean": "Boolean",
  "column": "Column",
  "dataType": "Data type",
  "row": "Row",
  "tableName": "Table name",
  "import": "Import",
  "dataSpaces": "Dataspaces",
  "noAssignedDataSpace": "No assigned dataspace",
  "dataspaces": "Dataspaces",
  "dataSpaceName": "Dataspace name",
  "dataSpaceCreation": "Dataspace creation",
  "dataSpaceDetail": "Dataspace detail",
  "wannaDeleteThisDataSpace": "Are you sure you want to delete this dataspace?",
  "dataSpaceDelete": "Delete dataspace",
  "allDataWillBeLost": "All data will be lost.",
  "tables": "Tables",
  "batches": "Batches",
  "tablesInDataSpace": "Tables in dataspace",
  "batchesInDataSpace": "Batches in dataspace",
  "searchTable": "Search table",
  "noTables": "No tables",
  "tableDetail": "Table detail",
  "structure": "Structure",
  "dataPreview": "Data preview",
  "noData": "No data",
  "confirmDeleteTable": "Are you sure you want to delete this table?",
  "importCsv": "Import CSV",
  "file": "File",
  "delimiter": "Delimiter",
  "semicolon": "Semicolon",
  "comma": "Comma",
  "tab": "Tab",
  "columns": "Columns",
  "importing": "Importing",
  "newBatch": "New batch",
  "editBatch": "Edit batch",
  "noBatches": "No batches",
  "confirmDeleteBatch": "Are you sure you want to delete this batch?",
  "batchName": "Batch name",
  "batchNamePlaceholder": "Enter batch name",
  "createBatch": "Create batch",
  "batchType": "Batch type",
  "dataLoadMethod": "Data load method",
  "typeCopy": "Copy",
  "typeCopyDesc": "Copies the input table without changes.",
  "typeAggregation": "Aggregation",
  "typeAggregationDesc": "Groups rows and aggregates the selected columns.",
  "typeCsd": "CSD",
  "typeCsdDesc": "Splits data into elementary segments across multiple input tables.",
  "output": "Output",
  "input": "Input",
  "inputs": "Inputs",
  "transformation": "Transformation",
  "copy": "Copy",
  "aggregation": "Aggregation",
  "inputTable": "Input table",
  "outputTable": "Output table",
  "outputTableName": "Output table name",
  "selectTable": "Select table",
  "outputIdName": "Output ID column",
  "outputFromName": "Output FROM column",
  "outputToName": "Output TO column",
  "inputIdName": "Input ID column",
  "inputFromName": "Input FROM column",
  "inputToName": "Input TO column",
  "includeColumns": "Include columns",
  "addColumn": "Add column",
  "alias": "Alias",
  "function": "Function",
  "selectFunction": "Select function",
  "groupBy": "Group by",
  "aggregateColumns": "Aggregate columns",
  "transformationSteps": "Transformation steps",
  "stepTable": "Step table",
  "stepColumns": "Step columns",
  "addStep": "Add step",
  "addInput": "Add input",
  "addTable": "Add table",
  "expressions": "Expressions",
  "expression": "Expression",
  "addExpression": "Add expression",
  "expressionPlaceholder": "e.g. [ColumnA] + [ColumnB]",
  "moveUp": "Move up",
  "moveDown": "Move down",
  "run": "Run",
  "runDataBatch": "Run batch",
  "areYouSureYouWantToRunThisDataBatch": "Are you sure you want to run this batch?",
  "running": "Running",
  "batchRunSuccessful": "Batch completed successfully",
  "batchRunUnsuccessful": "Batch run failed",
  "tableAlreadyExists": "Table already exists",
  "unknownError": "Unknown error",
  "type": "Type",
  "status": "Status",
  "origin": "Origin",
  "source": "Source",
  "rows": "Rows",
  "size": "Size",
  "created": "Created",
  "cancel": "Cancel",
  "edit": "Edit",
  "back": "Back",
  "continue": "Continue",
  "loading": "Loading",
  "lastRun": "Last run",
  "duration": "Duration",
  "saveAndRun": "Save and run",
  "addGroupBy": "Add group by",
  "transformations": "Transformations",
  "transformationTable": "Transformation table",
  "addTransformation": "Add transformation",
  "creationType": "Creation type",
  "createdBy": "Created by",
  "createdDate": "Created date",
  "export": "Export",
  "detail": "Detail",
  "recreateTable": "Recreate table",
  "copyBatch": "Copy batch",
  "newBatchName": "New batch name",
  "copying": "Copying",
  "batchCopySuccessful": "Batch copied successfully",
  "deleteBatch": "Delete batch",
  "deleting": "Deleting",
  "batchDeleteSuccessful": "Batch deleted successfully"
}